import { colors } from '@globals/themes/defaultTheme'
import SavingsOutlinedIcon from '@mui/icons-material/SavingsOutlined'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import { SxProps } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import MultiplicationT from '@shared/translations/MultiplicationT'
import { T } from '@transifex/react'

const cardStyle: SxProps = {
  p: 2,
  boxShadow: 'none',
  backgroundColor: colors.grayUltraLight,
  borderRadius: 4,
  border: 'none',
}

type AwardPointsRecipientAmountCardProps = {
  pointsAmount: number
  pointsRecipientCount: number
  totalSpend: number | null
  pointsBankAvailableBalance: number
}
const AwardPointsRecipientAmountCard: React.FC<AwardPointsRecipientAmountCardProps> = ({
  pointsAmount,
  pointsRecipientCount,
  totalSpend,
  pointsBankAvailableBalance,
}) => {
  return (
    <Paper component={Stack} sx={cardStyle} direction="row" useFlexGap gap={0.5} mt={2}>
      <SavingsOutlinedIcon color="disabled" />
      <Stack>
        <MultiplicationT
          factor1={
            <T
              _str="{pointsAmountNum, plural, one {{pointsAmount} point} other {{pointsAmount} points}}"
              pointsAmountNum={pointsAmount}
              pointsAmount={pointsAmount.toLocaleString()}
            />
          }
          factor2={
            <T
              _str="{recipientCountNum, plural, one {{recipientCount} recipient} other {{recipientCount} recipients}}"
              recipientCountNum={pointsRecipientCount}
              recipientCount={pointsRecipientCount.toLocaleString()}
            />
          }
          result={
            <T
              _str="{totalSpendNum, plural, one {{totalSpend} point used} other {{totalSpend} points used}}"
              totalSpendNum={totalSpend || 0}
              totalSpend={totalSpend?.toLocaleString() || '0'}
            />
          }
        />
        <Typography>
          <T
            _str="Remaining funds after sending = {remainingFunds}"
            remainingFunds={
              <T
                _str="{remainingPointsNum, plural, one {{remainingPoints} point} other {{remainingPoints} points}}"
                remainingPointsNum={pointsBankAvailableBalance - (totalSpend || 0)}
                remainingPoints={(pointsBankAvailableBalance - (totalSpend || 0)).toLocaleString()}
              />
            }
          />
        </Typography>
        <Typography variant="caption">
          <T _str="Awards are funded by point banks and don't impact your monthly point balance" />
        </Typography>
      </Stack>
    </Paper>
  )
}

export default AwardPointsRecipientAmountCard
